
let browserHistory;

export const setBrowserHistory = (history) => { browserHistory = history };

export const getBrowserHistory = () => browserHistory;

const ambienteKey = 'ambienteKey';

export const getAmbiente = () => localStorage.getItem(ambienteKey);


export const isAmbienteProd = () => getAmbiente() === 'live';

export const isAmbienteDev = () => getAmbiente() === 'sandbox';


export const salvarAmbiente = (ambiente) => {
  localStorage.setItem(ambienteKey, ambiente)
};

export const removerAmbiente = () => {
  localStorage.removeItem(ambienteKey)
};

export const tamanhoArquivoUpload = 20971520;

export const LIMITE_UPLOAD_ARQUIVO_ENCOMENDA = 3;
